import UomPaymentCodes from './uom-payment-codes-component';

import './uom-payment-codes.scss';

const MODULE_NAME = 'uom-payment-codes';
const module = angular.module(MODULE_NAME, [])
    .directive(UomPaymentCodes.DIRECTIVE_NAME, UomPaymentCodes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/uom-payment-codes/uom-payment-codes-module.js